import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class JNKR extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div className="jnkr">
        <Header
          props={this.props}
        />
        <div className="jnkr-headline">
            . JNKR
          </div>
          <div className="jnkr-text">
            A custom Single Page Application CMS (Content Management System) created from the ground up using:<p />
              <li> Node.JS</li>
              <li> React.JS (with Redux)</li>
              <li>Express.JS</li>
              <li>PostgreSQL</li>
            <p />
            Built and designed to imitate a Craigslist CMS for the buying and selling of junk items, like a web garage sale.
            <p />

            <div id="jnkr-link">
            <br />
                <a href="https://github.com/cozpon/consume-more-stuff" target='_blank' rel="noopener noreferrer">
                  View on Github
                </a>
            </div>

          </div>


          <div className="jnkr-images">
            <img src="/images/jnkr/RegisterLogin.gif" id="jnkr" alt="3"/>
            <div className="jnkr-label">
              Home View / Sidebar / Register / Login
            </div>
            <img src="/images/jnkr/LoginNewItem.gif" id="jnkr" alt="2"/>
            <div className="jnkr-label">
              Login and Create New Item
            </div>
            <img src="/images/jnkr/EditItem.gif" id="jnkr" alt="1"/>
            <div className="jnkr-label" style={{paddingBottom:'2%'}}>
              Single Item View / Edit Item
            </div>
          </div>

          <div id="jnkr-features">
            <div className="jnkr-text">
              <h2>Features</h2>
              <ul>
                <li> Login / Register a personal account</li>
                <li> Create and post a new item with image uploaded via Node.JS </li>
                <li> Edit, Delete or Mark As Sold capabilities on your item</li>
              </ul>
            </div>
          </div>
      </div>
    );
  }
}

export default JNKR;



